import { render, staticRenderFns } from "./ShopNav.vue?vue&type=template&id=5a2e7dd8&"
import script from "./ShopNav.vue?vue&type=script&lang=js&"
export * from "./ShopNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports